import { trim } from 'lodash';
import { camelize } from 'inflection';

export const buildStylesHash = (stylesInput) => Object.fromEntries(
    trim(stylesInput, '; ')
        .split(';')
        .map((ruleString) => ruleString.split(':').map(trim))
        .map(([k, v]) => [camelize(k.replace('-', '_'), true), v])
);